import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseCardsTotalizerProps<T> = {
  filters?: {
    type?: string;
    number?: string;
    company_id?: string;
  };
  mapper?: (data: any) => T,
};

export const useCardsTotalizer = <T,>({
  filters: { type, number, company_id } = {},
  mapper = Mapper.default<T>(),
}: UseCardsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['clientCardsTotalizer', type, number, company_id],
    queryFn: () => {
      return privateAxios.get(`/client/cards/totalizer`, {
        params: {
          'q[type_eq]': type,
          'q[number_eq]': number,
          'q[company_id_eq]': company_id,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
